import useBusinessNavigate from '../lib/useBusinessNavigate.js';
import Loading from '../components/Loading';
import { useEffect, useState } from 'react';
import * as Toast from '../lib/Toast.js';
import { get } from '../lib/Api';
import { Link, useNavigate, useParams } from 'react-router-dom';
import RequiresAuth from '../components/RequiresAuth.jsx';

const DoJoin = ({ businessId, token }) => {
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        get(`/api/business/${businessId}/invites/join?token=${token}`)
            .then(result => {
                Toast.success(`Successfully joined ${result.businessName}`);
                navigate(`/business/${businessId}`);
            })
            .catch(err => {
                console.log(err);
                setError(
                    'Invite was invalid, it may have already been used or expired. Please ask the business for a new invite link',
                );
            });
    }, []);

    return (
        <div className="min-h-screen w-full flex items-center justify-center">
            {!error && <Loading />}
            {!!error && <div className="p-6 panel text-red-500">{error}</div>}
        </div>
    );
};

const JoinPage = ({}) => {
    const navigate = useNavigate();
    const { businessId, token } = useParams();

    return (
        <RequiresAuth>
            <DoJoin businessId={businessId} token={token} />
        </RequiresAuth>
    );
};

export default JoinPage;
